export default __webpack_public_path__ + "static/media/Interactive Map.cc2557e0.svg";